import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
class getAdicionales extends Component {
  constructor(props){
    super(props);
    this.state = {
        adicional : []
    }
  }
  cargar_adicionales =()=>{
    const url= this.props.dir_url + "webapp/getAdicionalesComplementos";
    const token =  this.props.token
    var obj = { accion:'getAdicionalesComple', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          adicional : data[0].msg
        })
      }
    })
    .catch(console.log)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }

get_opcion_no =()=>{

}


/*/*<th>id_complemento</th>
<th>producto</th>
<th>presentacion</th>
<th>precio</th>
<th>orden</th>
<th>observacion_adicional</th>
<th>cant_minima</th>
<th>porc_descuento</th>
<th>Ópciones</th>*/

  getgrabarRubro =(id_acumulador)=>{
    const array_adicional = this.state.adicional
    let id_complemento
    let producto
    let presentacion
    let precio
    let orden
    let observacion_adicional
    let cant_minima
    let porc_descuento

    array_adicional.forEach(det => {
      if(Number(det.id_acumulador)===Number(id_acumulador)){
        producto = det.producto
        presentacion = det.presentacion
        precio = det.precio
        orden = det.orden
        observacion_adicional = det.observacion_adicional
        cant_minima = det.cant_minima
        porc_descuento = det.porc_descuento
        id_complemento = det.id_complemento
      }
    });
    if(Number(id_complemento)<=0){
      return null
    }
    const url= this.props.dir_url + "webapp/getGrabarAdicional";
    const token =  this.props.token
    var obj = { accion:'grabaradicionaldata',token, producto,presentacion,precio,orden,observacion_adicional,cant_minima,porc_descuento,id_complemento};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_adicionales()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }

/*/*<th>id_complemento</th>
<th>producto</th>
<th>presentacion</th>
<th>precio</th>
<th>orden</th>
<th>observacion_adicional</th>
<th>cant_minima</th>
<th>porc_descuento</th>
<th>Ópciones</th>*/
  handleChange = (event , index ,name) => {
    var adicional = this.state.adicional
    let value = event.target.value
    let checked = event.target.checked

    adicional.forEach(det => {
      if(Number(det.id_acumulador)===Number(index)){
        if(name==="producto"){
          det.producto = value;
        }
        if(name==="presentacion"){
          det.presentacion = value;
        }
        if(name==="precio"){
          det.precio = value;
        }
        if(name==="orden"){
          det.orden = value;
        }
        if(name==="observacion_adicional"){
          det.observacion_adicional = value;
        }
        if(name==="cant_minima"){
          det.cant_minima = value;
        }
        if(name==="porc_descuento"){
          det.porc_descuento = value;
        }
      }
    });
    this.setState({adicional});
  }


  llenar_adicionales =()=>{
    //console.log("actualizar")
    //id_rubro, rubro, orden, uuid_imagen, activo
    // file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}
    //token_image
    //app-delivery-8b998-60x60 images%2F39295c1e-1cfb-4afd-adc2-4bc662f5f6e1
    //https://firebasestorage.googleapis.com/v0/b/app-delivery-8b998-250x200/o/images%2Fb5c56d54-4a34-4e9e-b3db-27ee28207c1e_250x200.png?alt=media&token=d79f2b7b-9479-4a31-841d-c47587722b95


    /*<th>id_complemento</th>
    <th>producto</th>
    <th>presentacion</th>
    <th>precio</th>
    <th>orden</th>
    <th>observacion_adicional</th>
    <th>cant_minima</th>
    <th>porc_descuento</th>
    <th>Ópciones</th>*/
    const adicional = this.state.adicional
    return(
       <React.Fragment>
       <tbody>
        {
          (adicional)?
          adicional.map((det , index) => (
            <tr key={index}>
              <td>{det.id_complemento}</td>
              <td> {det.producto|| ''}</td>
              <td> {det.presentacion|| ''}</td>
              <td> <input  type="text" value={det.precio|| ''} onChange={(e) => {this.handleChange( e , det.id_acumulador ,"precio")}} /></td>
              <td> <input  type="text" value={det.orden|| ''} onChange={(e) => {this.handleChange( e , det.id_acumulador ,"orden")}} /></td>
              <td> <input  type="text" value={det.observacion_adicional|| ''} onChange={(e) => {this.handleChange( e , det.id_acumulador ,"observacion_adicional")}} /></td>
              <td> <input  type="text" value={det.cant_minima|| ''} onChange={(e) => {this.handleChange( e , det.id_acumulador ,"cant_minima")}} /></td>
              <td> <input  type="text" value={det.porc_descuento|| ''} onChange={(e) => {this.handleChange( e , det.id_acumulador ,"porc_descuento")}} /></td>
              <td>
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getgrabarRubro(det.id_acumulador)}>
                  Grabar
                </button>
              </td>
            </tr>
          )) :''
      }
      </tbody>
      </React.Fragment>
    )
  }
  render() {
    //<GetUploadImage file_xxx={'app-delivery-8b998-60x60'}  firebase={firebase} getUUID={this.getUUID} width={'60px'} height={'60px'}  token_image={''} />
    //id_datos_empresa, logo, datos_empresa, condiciones
    return(
      <React.Fragment>
      <div className="" style={{"backgroundColor":"white","color":"black"}}>
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_">Lista de Precios(Adicionales)</div>
        </div>
      </div>
      <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
          <table className="tb_pedidos">
          <thead>
          <tr>
            <th>id_complemento</th>
            <th>producto</th>
            <th>presentacion</th>
            <th>precio</th>
            <th>orden</th>
            <th>observacion_adicional</th>
            <th>cant_minima</th>
            <th>porc_descuento</th>
            <th>Ópciones</th>
          </tr>
          </thead>
          {this.llenar_adicionales()}
        </table>
        <br/><br/><br/><br/><br/>
      </div>
      </React.Fragment>
    )
  }
  //cargar_informacion
  componentDidMount (){
    this.cargar_adicionales()
  }

}
export default getAdicionales;
